module.exports = __webpack_public_path__ + "img/home_bg.d5716091.png";